module.exports = __webpack_public_path__ + "0b6ce17e2967839b8ed1119a1656943f.svg";